"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  root: {
    width: '100%'
  },
  padding: {
    padding: theme.spacing(2)
  },
  divider: {
    marginBottom: theme.spacing(1)
  },
  pageTitle: {
    fontSize: theme.typography.pxToRem(26),
    padding: theme.spacing(0, 0, 1, 0)
  }
}), {
  name: 'PageTitleDescription'
});
var _default = exports.default = useStyles;